import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FileText, ArrowRight, PenLine } from "lucide-react";
import api from "../lib/api";
import { Spinner, SectionLabel, Pill } from "../components/Primitives";

export default function Assignments() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/coursework").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="assignments-page">
      <div className="border-b border-edge bg-ash">
        <div className="mx-auto max-w-7xl px-6 py-20 md:px-12">
          <SectionLabel>Coursework</SectionLabel>
          <h1 className="font-serif text-5xl font-semibold text-bone lg:text-6xl">Assignments</h1>
          <p className="mt-5 max-w-2xl text-lg text-muted">
            Short-answer questions and writing tasks drawn straight from the source documents. Read, respond, and submit.
          </p>
        </div>
      </div>

      {loading ? (
        <Spinner />
      ) : items.length === 0 ? (
        <div className="mx-auto max-w-3xl px-6 py-24 text-center">
          <p className="border border-dashed border-edge p-10 text-muted" data-testid="assignments-empty">No assignments published yet.</p>
        </div>
      ) : (
        <div className="mx-auto max-w-7xl px-6 py-16 md:px-12">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {items.map((c, i) => (
              <motion.div key={c.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.06 }}>
                <Link to={`/assignments/${c.slug}`} data-testid={`assignment-card-${c.slug}`}
                  className="group flex h-full flex-col border border-edge bg-ash p-6 transition-colors hover:border-gold/50">
                  <FileText className="h-6 w-6 text-gold" />
                  <h3 className="mt-4 font-serif text-2xl text-bone group-hover:text-gold">{c.title}</h3>
                  <div className="mt-3 flex flex-wrap gap-2">
                    <Pill tone="muted">{c.questions?.length || 0} questions</Pill>
                    <Pill tone="gold"><PenLine className="mr-1 inline h-3 w-3" /> 1 writing task</Pill>
                  </div>
                  <span className="mt-auto pt-5 inline-flex items-center gap-1 text-sm text-gold">
                    Start assignment <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </span>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
